export default {
    getModelDoc: (state) => {
        return state.documento
    }
}